'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = require('reselect');

var _getAvailabilityOfficeHoursWillReturnMessage = require('../../availability/selectors/getAvailabilityOfficeHoursWillReturnMessage');

var getShouldShowOfficeHoursEmailCaptureMessage = (0, _reselect.createSelector)([_getAvailabilityOfficeHoursWillReturnMessage.getAvailabilityOfficeHoursWillReturnMessage], function (officeHoursMessage) {
  return !!officeHoursMessage;
});

exports.default = getShouldShowOfficeHoursEmailCaptureMessage;
module.exports = exports['default'];